<template>
  <div id="activity">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content">
        <div class="main-title">
          {{ language === "cn" ? "大会活动" : "Congress Events" }}
        </div>
        <div class="content_box">
          <div class="activity-button" @click="toOutchain()">
            <p>
              {{
                language === "cn"
                  ? stepMenuList[active].children[0].name
                  : stepMenuList[active].children[0].name_en
              }}
            </p>
            <!-- <p>
              {{
                language === "cn"
                  ? "进入第三方平台"
                  : "Access a third-party platform"
              }}
            </p> -->
            <div>{{ language === "cn" ? "进入 >" : "Enter >" }}</div>
          </div>
          <div class="activity-richtext" v-html="content"></div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">
              {{ language === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('next')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <!-- 24.10.15 zhang  不可配置 ljj 展商认证添加跳过按钮 -->
            <div class="btn" @click="next('skip')">
              {{ language === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('known')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import { skipOrNextStep, companyMenuDetail } from "@/api/api";
export default {
  components: { top, navMenu },
  name: "activity",
  data() {
    return {
      stepMenuList: [],
      detail: "",
      active: 0,
      content: "",
      language: "",
    };
  },
  created() {
    this.language = localStorage.getItem("language");
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/activity";
    });
    this.detail = stepMenuList[index];
    this.active = index;
    this.id = stepMenuList[index].id;
    this.getContent();
  },
  methods: {
    async getContent() {
      const res = await companyMenuDetail({ id: this.id });
      let { data } = res.data;
      if (this.language === "cn") {
        if (data.content) {
          data.content = data.content.replace(
            /<img/g,
            "<img style='max-width:100%;height:auto;'"
          );
          data.content = data.content.replace(
            /<p/g,
            "<p style='max-width:100%;'"
          );
        }
        this.content = data.content;
      } else if (this.language === "en") {
        if (data.content_en) {
          data.content_en = data.content_en.replace(
            /<img/g,
            "<img style='max-width:100%;height:auto;'"
          );
          data.content_en = data.content_en.replace(
            /<p/g,
            "<p style='max-width:100%;'"
          );
        }
        this.content = data.content_en;
      }
    },
    async toOutchain() {
      let url =
        this.language === "cn"
          ? this.stepMenuList[this.active].children[0].link_url
          : this.stepMenuList[this.active].children[0].link_url_en;
      window.open(url, "_target");
      const res = await skipOrNextStep({
        action: 2,
        mark: this.detail.children[0].mark,
      });
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrNextStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(
              this.language === "cn" ? "操作成功" : "Operation successful"
            );
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content_box {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 30px 20px 300px;
  display: flex;
  .activity-button {
    width: 360px;
    height: 114px;
    padding: 24px 18px 16px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #8ac7f3, #358ece);
    border-radius: 16px;
    position: relative;
    cursor: pointer;
    margin-right: 80px;
    > p {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      margin-left: 10px;
      margin-bottom: 10px;
    }
    > p:nth-child(2) {
      font-size: 14px;
    }
    > div:last-child {
      color: #fff;
      font-weight: 700;
      position: absolute;
      right: 18px;
      bottom: 16px;
    }
  }
  .activity-button:hover {
    background: linear-gradient(
      135deg,
      #72bdf3 0%,
      #55a9e6 23%,
      #1880cc 75%,
      #0070c2 100%
    );
  }
  .activity-richtext {
    height: 500px;
    width: calc(100% - 480px);
    background-color: #f2f6fb;
    border-radius: 8px;
    overflow-y: scroll;
  }
  .activity-richtext::-webkit-scrollbar {
    display: none;
  }
  // .content_html {
  //   width: 100%;
  //   padding: 20px;
  //   box-sizing: border-box;
  //   border-radius: 10px;
  //   background: #fff;
  //   line-height: 30px;
  //   p > img {
  //     width: 100px !important;
  //     background-color: red !important;
  //   }
  // }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
</style>
